module.exports = __webpack_public_path__ + "static/media/btg_11.4bac5bf1.png";